
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABRUExURQAAAP////////////////////////////////// /////+Lm78XN35mpx4udwOnt8+ns8+Ln75mpyKGvzK+709Pa59vg66i1z6CvzKi20AAAAPaRXq0A AAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAA AAd0SU1FB+cMBAM5IyOiuV0AAACNSURBVCjPzdLLDsIgEIXhw3CrU0W8tfr+L+pgq4GGiQs3/gkL +DJhM4BkyHKT8wFLceBOFF/muJsrOrASAYHVDLyOhPbHcawuFrXsDykdq4cP5iLSqYfnlHRMv+Pl etNRzr/jNL/xLmfODeZH07TiZrXqHEhHD6OjrKc6St9WE7E7uyy1FPxm2tKuvD8ByQ0f3l1OPakA AAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMTItMDRUMDI6MzI6MTErMDA6MDBnkLLfAAAAJXRFWHRk YXRlOm1vZGlmeQAyMDIzLTEyLTA0VDAyOjMyOjExKzAwOjAwFs0KYwAAACh0RVh0ZGF0ZTp0aW1l c3RhbXAAMjAyMy0xMi0wNFQwMzo1NzozNSswMDowMCS40FAAAAAASUVORK5CYII="}})])
          )
        }
      }
    